import { useState } from 'react';

import { ConfirmDialog } from '@app/hoc/confirm-dialog/ConfirmDialog';
import { Input } from '@app/components';

// admin-emailbeheer blok A stap 5, opdracht §5.1: all four actions require a reason, logged to
// email_admin_action. One shared dialog so every action asks for it the same way.
export const ReasonPromptDialog: React.FC<{
  trigger: React.ReactElement;
  title: string;
  text?: string;
  actionLabel?: string;
  loading?: boolean;
  onConfirm: (reason: string) => void;
}> = ({ trigger, title, text, actionLabel = 'Confirm', loading, onConfirm }) => {
  const [reason, setReason] = useState('');

  return (
    <ConfirmDialog
      trigger={trigger}
      title={title}
      text={text}
      confirmText={actionLabel}
      confirmButtonProps={{ disabled: !reason.trim(), loading }}
      onConfirm={() => {
        const trimmed = reason.trim();
        if (!trimmed) {
          return;
        }
        onConfirm(trimmed);
        setReason('');
      }}
    >
      <Input
        label="Reason"
        labelRequired
        placeholder="Why are you doing this?"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        multiline
        rows={2}
        className="mb-6 w-full"
      />
    </ConfirmDialog>
  );
};
